/**
 * SecuredZone-Komponente
 * 
 * Layout-Wrapper für alle authentifizierten Seiten.
 * Stellt die Grundstruktur mit Sidebar, TopBar, Breadcrumbs und TitleBar bereit.
 * 
 * @module SecuredZone
 */

import React from 'react';
import SideBar from './template/SideBar';
import TopBar from './template/TopBar';
import TitleBar from './template/TitleBar';
import AlarmOverlay from './AlarmOverlay';
import '../css/main.css';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link } from '@mui/material';

/**
 * SecuredZone-Komponente
 * 
 * Hauptlayout-Komponente für alle geschützten Seiten.
 * 
 * @param {Object} props - Komponenten-Props
 * @param {React.ReactNode} props.children - Inhalt der Seite
 * @param {string} props.title - Titel der Seite (wird in TitleBar angezeigt)
 * @param {Object} props.breadcrumbs - Breadcrumb-Navigation (z.B. { '/': 'Dashboard', '/devices': 'Koffer' })
 * @param {React.ReactNode} props.loading - Loading-Indikator (z.B. LinearProgress)
 * @param {Object} props.menu - Menü-Konfiguration für TitleBar (optional)
 * 
 * @returns {JSX.Element} SecuredZone-Komponente
 */
const SecuredZone = (props) => {
  return (
    <>
      <AlarmOverlay />
      <div className="main-screen">
        {/* Header-Bereich mit TopBar (Benutzer-Menü, Dark Mode Toggle, etc.) */}
        <div className="main-header">
          <TopBar />
        </div>
        
        {/* Hauptinhalt-Bereich */}
        <div className="main-content">
          {/* Sidebar mit Navigation */}
          <div className="main-menu">
            <SideBar />
          </div>
          
          {/* Seiteninhalt */}
          <div className="main-page">
            {/* Loading-Indikator (wird oben angezeigt) */}
            {props.loading}
            
            <div>
              {/* Breadcrumb-Navigation */}
              <div className="bread-crumbs">
                {props.breadcrumbs ? (
                  <Breadcrumbs separator="›" aria-label="breadcrumb">
                    {Object.entries(props.breadcrumbs).map((item, index) => {
                      return (
                        <Link
                          key={index}
                          color="inherit"
                          component={RouterLink}
                          to={item[0]}
                        >
                          {item[1]}
                        </Link>
                      );
                    })}
                  </Breadcrumbs>
                ) : (
                  ''
                )}
              </div>
              
              {/* Titel-Leiste mit optionalem Menü */}
              <TitleBar menu={props.menu} text={props.title} />
              
              {/* Hauptinhalt der Seite */}
              <div className="main-page-content">
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecuredZone;
